<div class="modal-body" [class.scrollbar-minimal]="maxHeight" [ngStyle]="maxHeight ? { 'max-height': maxHeight } : null">
    <ng-content></ng-content> 
 </div>
 